import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendFundTransferAdviceDc } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const FundTransferAdviceDirectCredit = (props) => {
  const {
    goToFundTransferDirectDebit,
    goToFundTransferDirectCredit,
    sendType,
    fundTransferAdviceDc,
    isLoading,
  } = props;

  const handleFundTransferAdviceDc1 = () => {
    const payload = {
      type: "success",
    };
    sendType(payload);
  };

  const handleFundTransferAdviceDc2 = () => {
    const payload = {
      type: "balance_enquiry",
    };
    sendType(payload);
  };

  const request = fundTransferAdviceDc && fundTransferAdviceDc.request;
  const response = fundTransferAdviceDc && fundTransferAdviceDc.response;

  return (
    <InwardXml
      prev={goToFundTransferDirectCredit}
      next={goToFundTransferDirectDebit}
      title={"Fund Transfer Advice Direct Credit"}
      request={request}
      response={response}
      optiontitle1={"Success"}
      optiontitle2={"Balance Enquiry(BE)"}
      handleCase1={handleFundTransferAdviceDc1}
      handleCase2={handleFundTransferAdviceDc2}
      isLoading={isLoading}
    />
  );
};

FundTransferAdviceDirectCredit.propTypes = {
  fundTransferAdviceDc: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  goToFundTransferDirectCredit: PropTypes.func,
  goToFundTransferDirectDebit: PropTypes.func,
  isLoading: PropTypes.bool,
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendFundTransferAdviceDcSuccess:
      state.inwardInteraction.sendFundTransferAdviceDcSuccess,
    fundTransferAdviceDc: state.inwardInteraction.sendFundTransferAdviceDc,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendFundTransferAdviceDc(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundTransferAdviceDirectCredit);
